import React, { createContext, useState, useEffect, useContext } from 'react';
import { coreAPI } from '../services/api';

const OrganizationContext = createContext();

export const useOrganization = () => {
  const context = useContext(OrganizationContext);
  if (!context) {
    throw new Error('useOrganization must be used within OrganizationProvider');
  }
  return context;
};

export const OrganizationProvider = ({ children }) => {
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOrganization();
  }, []);

  const fetchOrganization = async () => {
    try {
      setLoading(true);
      const response = await coreAPI.getCouncilors();
      const organizations = response.data.results || response.data;
      if (organizations && organizations.length > 0) {
        setOrganization(organizations[0]);
      }
      setError(null);
    } catch (err) {
      console.error('Error fetching organization:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const value = {
    organization,
    loading,
    error,
    refetch: fetchOrganization
  };

  return (
    <OrganizationContext.Provider value={value}>
      {children}
    </OrganizationContext.Provider>
  );
};
